import React, { useContext } from "react";
import CameraFeed from "components/CameraFeed";
import { CommonContext } from "hooks/CommonContext";
import InitCameraOffBox from "components/ui-components/InitCameraOffBox";
import { common } from "utils/constant";
import CameraToggleOnJoinPage from "components/toggle-button/CameraToggleOnJoinPage";
import AudioToggleOnJoinPage from "components/toggle-button/AudioToggleOnJoinPage";

const STYLES = `
  /* Container — 4:3, flex column so children stack naturally */
  #videoContainer.join-page-video-container {
    position: relative !important;
    width: 100% !important;
    aspect-ratio: 4 / 3 !important;
    overflow: hidden !important;
    border-radius: 0 !important;
    background: #0c1428 !important;
    display: flex !important;
    flex-direction: column !important;
  }

  /* CameraFeed fills the whole container */
  #videoContainer.join-page-video-container .camera-feed-wrapper,
  #videoContainer.join-page-video-container video {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
    display: block !important;
    flex: 1 !important;
  }

  /* Controls pill — absolute over the video, always centered */
  .cjpb-controls {
    position: absolute !important;
    bottom: 16px !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 8px !important;
    padding: 6px 10px !important;
    background: rgba(8, 13, 28, 0.78) !important;
    backdrop-filter: blur(12px) !important;
    -webkit-backdrop-filter: blur(12px) !important;
    border-radius: 50px !important;
    border: 1px solid rgba(255, 255, 255, 0.08) !important;
    z-index: 10 !important;
  }
`;

let _inj = false;
const inject = () => {
  if (_inj) return;
  const s = document.createElement("style");
  s.textContent = STYLES;
  document.head.appendChild(s);
  _inj = true;
};

const CameraJoinPageBox = () => {
  inject();
  const { userOwnData } = useContext(CommonContext);

  return (
    <div id="videoContainer" className="join-page-video-container">
      {/* Video or camera-off — both rendered as direct flex children, fills container */}
      {userOwnData.isCameraOn ? <CameraFeed /> : <InitCameraOffBox />}

      {/* Controls always float above via absolute */}
      {userOwnData.interviewType !== common.agent && (
        <div className="cjpb-controls">
          <CameraToggleOnJoinPage />
          <AudioToggleOnJoinPage />
        </div>
      )}
    </div>
  );
};

export default CameraJoinPageBox;